import { createContext, FC, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getRoleById, putRoleById } from "../../api/broker";
import { SingleRoleContextProps } from "../../interfaces/SuperAdmin/ContextProps/iSingleRole";
import {
  EditRoleFields,
  iDataRoles,
} from "../../interfaces/SuperAdmin/Pages/iDataRoles";

const SingleRoleContext = createContext<SingleRoleContextProps>(
  {} as SingleRoleContextProps
);

interface Props {
  children: React.ReactNode;
}

const SingleRoleProvider: FC<Props> = ({ children }) => {
  const { idRol } = useParams();
  const [role, setRole] = useState<iDataRoles>({} as iDataRoles);
  const [isLoading, setIsLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isPermissionsTab, setIsPermissionsTab] = useState<0 | 1>(0);

  // Funcion para editar un rol
  const editData = async (body: EditRoleFields, id: string) => {
    setIsEditing(true);
    try {
      const res = await putRoleById(body, id);
      console.log(res);

      if (res.data.statusCode === 200) {
        setRole(res.data.body);
        toast.success("Rol editado exitosamente");
      } else {
        toast.error("Error al editar el rol");
      }
      closeModal();
    } catch (error) {
      console.log(error);
      toast.error("Error al editar el rol");
    } finally {
      setIsEditing(false);
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Hacemos el fetch del rol
  useEffect(() => {
    const fetchAll = async () => {
      if (idRol) {
        setIsLoading(true);
        try {
          //Fetch del rol y todas las suscripciones
          const rolRes = await getRoleById(idRol);
          console.log(rolRes);

          if (rolRes.data.statusCode === 200) {
            setRole(rolRes.data.body); // Asignamos el rol
          } else {
            toast.error("Error al obtener el rol");
          }
        } catch (error) {
          console.log(error);
          toast.error("Error al obtener el rol");
        } finally {
          setIsLoading(false);
        }
      }
    };
    fetchAll();
  }, [idRol]);

  return (
    <SingleRoleContext.Provider
      value={{
        role,
        isLoading,
        isModalOpen,
        isEditing,
        isPermissionsTab,
        openModal,
        closeModal,
        editData,
        setIsPermissionsTab,
      }}
    >
      {children}
    </SingleRoleContext.Provider>
  );
};

const useSuperAdminSingleRol = () => useContext(SingleRoleContext);

export { SingleRoleProvider, useSuperAdminSingleRol };

